import { render, staticRenderFns } from "./FeaturedService.vue?vue&type=template&id=41ce2554&scoped=true&"
import script from "./FeaturedService.vue?vue&type=script&lang=ts&"
export * from "./FeaturedService.vue?vue&type=script&lang=ts&"
import style0 from "./FeaturedService.vue?vue&type=style&index=0&id=41ce2554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ce2554",
  null
  
)

export default component.exports